import { Component, Inject, OnInit } from "@angular/core";
import { Firestore } from "@angular/fire/firestore";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { SyndicateRepositoryService } from "src/app/pages/syndicate/syndicate-repository.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";

@Component({
  selector: "app-top-notification",
  templateUrl: "./top-notification.component.html",
  styleUrls: ["./top-notification.component.scss"],
  standalone: true,
  imports: [IonicModule],
})
export class TopNotificationComponent implements OnInit {
  selectedId: number = null;
  messageData: any;
  public backgroundImage: string;
  public userId: string;
  constructor(
    private firestore: Firestore,
    private matDialogRef: MatDialogRef<TopNotificationComponent>,
    private syndicateService: SyndicateRepositoryService,
    private GTMSegment: GTMSegmentService,
    private matDialog: MatDialog,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {
    this.messageData = data;
    this.GTMSegment.GTMPopupInitialization("DeclineInvitaion");
    this.backgroundImage =
      this.messageData?.template_data?.background_url != ""
        ? this.messageData?.template_data?.background_url
        : "../../../assets/images/bluebubble.png";
  }

  async ngOnInit() {
    await this.authService.getUid("TopNotificationComponent").then((uid) => {
      this.userId = uid;
    })
  }

  declineInvitation() {
    if (this, this.userId === "null" || this.userId == null || !window.navigator.onLine) {
      return;
    }

    const path_id = "i6Y4dDCDpxx6moWivjMh";
    const doc_data = { hide: true };
    const dv = { docId: this.data.psInvitation?.limb_msg_id };
    const method = "update";

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      dv,
      method,
    }).subscribe({
      error: (error) => {
        console.error("Error updating document:", error);
        return error;
      }
    });


    this.matDialogRef.close();

    this.syndicateService.updateInvitationId(this.data.psInvitation.invitation_id);
    this.syndicateService.syndicateInvitedDetails$?.subscribe((doc: any) => {
      if (doc?.invited_by) {
        doc.invited_by.onSnapshot((ref) => {
          if (!ref || !ref.id) return;

          doc["invitee"] = ref?.data();
          doc["invitee"]["id"] = ref.id;

          this.syndicateService
            .joinSyndicateInvitation(
              this.data.psInvitation.ps.id,
              doc.invitee.id,
              doc.invitee.id,
              "Declined"
            )
            .subscribe(
              (res) => {
                if (res?.status === "rejected") {
                  this.authService.getConstantsMsg(res?.error_code).then((translatedMsg) => {
                    const defaultMsg = {
                      message: {
                        line_1: "Something went wrong!",
                        line_2: "",
                      },
                      style: {
                        icon: "tick circle error.svg",
                        type: "Error",
                      },
                    };
                    this.authService.showToastMessage(translatedMsg, defaultMsg);
                  }).catch((error) => {
                    console.error('Error showing toast message:', error);
                    return error;
                  });
                  return;
                }
                if (res?.response?.status === "Declined") {
                  // Handle declined response
                }
              },
              (err) => {
                console.error('Error processing syndicate invitation:', err);
                return err;
              }
            );
        });
      }
    });
  }

  onReveal(selectedId: number) {
    this.selectedId = selectedId;
  }

  onCTA() {
    this.close();
    this.router.navigate([this.messageData?.destination]);
  }

  close() {
    this.matDialogRef.close();
  }
}
